
import React from 'react';

/**
 * BrandedLoader component
 * - Modern, yarn-inspired animated SVG
 * - Uses primary purple for seamless brand integration
 * - Responsive and visually smooth for all backgrounds
 */
const BrandedLoader = () => {
  // Accessibility labels maintained
  return (
    <div className="flex justify-center items-center py-10" aria-label="Loading content">
      <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        xmlns="http://www.w3.org/2000/svg"
        aria-busy="true"
        aria-label="Loading"
        className="animate-float"
      >
        {/* Concentric animated yarn windings */}
        <circle
          cx="28"
          cy="28"
          r="22"
          stroke="#622066"
          strokeWidth="3"
          fill="none"
          className="opacity-40"
        >
          <animate
            attributeName="stroke-dasharray"
            values="40,140;80,100;140,40;80,100;40,140"
            dur="2.5s"
            repeatCount="indefinite"
          />
        </circle>
        <circle
          cx="28"
          cy="28"
          r="16"
          stroke="#D68AD9"
          strokeWidth="3"
          fill="none"
          strokeDasharray="50,25"
          className="opacity-70"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 28 28"
            to="360 28 28"
            dur="1.4s"
            repeatCount="indefinite"
          />
        </circle>
        <circle
          cx="28"
          cy="28"
          r="10"
          stroke="#622066"
          strokeWidth="2.5"
          fill="none"
          strokeDasharray="10,16"
          className="opacity-100"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="360 28 28"
            to="0 28 28"
            dur="1s"
            repeatCount="indefinite"
          />
        </circle>
        {/* Center thread for a yarn feel */}
        <circle
          cx="28"
          cy="28"
          r="4"
          fill="#622066"
          className="opacity-90"
        >
          <animate
            attributeName="r"
            values="3.2;4;5;4;3.2"
            dur="1.7s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    </div>
  );
};

export default BrandedLoader;
